import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_7 = {
  for: "company-name",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_9 = { class: "block text-sm" }
const _hoisted_10 = { value: null }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mt-10 flex justify-between" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "flex flex-row-reverse" }

import { ref, onMounted, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { NomenclatureActions } from "@/store/modules/nomenclature/actions";
import { NomenclatureGetters } from "@/store/modules/nomenclature/getters";
import { PencilIcon } from "@heroicons/vue/solid";
import { EyeIcon } from "@heroicons/vue/solid";
import {
  DotsHorizontalIcon,
  UploadIcon,
  PlusIcon,
  SearchIcon,
} from "@heroicons/vue/outline";
import VueTableLite from "vue3-table-lite/ts";
import StatusLabel from "@/components/common/StatusLabel.vue";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { ActionMenu } from "@/components/common";
import { Button } from "@/components/common";
import NomenclatureExcelUploadModal from "@/components/documents/NomenclatureExcelUploadModal.vue";
import { t } from "@/i18n";
import { getCommonStatusOptions } from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

const dataProvider = computed(() => {
  return store.getters[NomenclatureGetters.GET_DATA_PROVIDER];
});
const nomenclatures = computed(() => {
  return dataProvider.value.items;
});
const pager = computed(() => {
  return dataProvider.value.pager;
});
const statusOptions = computed(() => getCommonStatusOptions());

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("common.title"),
      field: "name",
      sortable: false,
    },
    {
      label: t("common.index"),
      field: "index",
      sortable: false,
    },
    {
      label: t("nomenclatureList.ordNumber"),
      field: "count",
      sortable: false,
    },
    {
      label: t("nomenclatureList.indOrdNumber"),
      field: "subCount",
      sortable: false,
    },
    {
      label: t("common.status"),
      field: "status",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ],
  rows: nomenclatures,
  totalRecordCount: 0,
});

const dropDownActions = [
  {
    text: t("common.details"),
    icon: EyeIcon,
    iconColor: "text-slate-500",
    action: async (id: string) => {
      await router.push({ name: "NomenclatureDetails", params: { id: id } });
    },
  },
  {
    text: t("common.edit"),
    icon: PencilIcon,
    iconColor: "text-green-500",
    action: async (id: string) => {
      await router.push({ name: "NomenclatureEdit", params: { id: id } });
    },
  },
];

const getPage = async (page: number) => {
  await store.dispatch(NomenclatureActions.FETCH_DATA_PROVIDER, {
    page: page,
  });
};

// Filter
const filter = ref({
  name: "",
  status: null,
});
const updateFilter = async () => {
  try {
    await store.dispatch(NomenclatureActions.FETCH_DATA_PROVIDER, filter.value);
  } catch (e) {
    console.log(e);
  }
};

// Excel Upload Modal
const nomenclatureExcelUploadModalIsShow = ref(false);

onMounted(async () => {
  await store.dispatch(NomenclatureActions.FETCH_DATA_PROVIDER, {
    page: 1,
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("nomenclatureList.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("common.name")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "company-name",
            type: "search",
            class: "w-full flex-none w-2/5 rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.name) = $event))
          }, null, 512), [
            [_vModelText, filter.value.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("common.status")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "user-status",
            name: "user-status",
            class: "block w-full flex-1 rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.status) = $event))
          }, [
            _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("common.allStatuses")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusOptions), (status, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: index,
                key: index
              }, _toDisplayString(status), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(Button), {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (updateFilter())),
          class: "btn-search"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(Button), {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (nomenclatureExcelUploadModalIsShow.value = true)),
            class: "flex px-10 mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UploadIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("nomenclatureList.upload")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: { name: 'NomenclatureCreate' } }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), { class: "flex px-10" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusIcon), { class: "button-icon mr-2" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("common.create")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      status: _withCtx((data) => [
        _createVNode(StatusLabel, {
          label: data.value.status
        }, null, 8, ["label"])
      ]),
      action: _withCtx((data) => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(ActionMenu), {
            actions: dropDownActions,
            item: data.value
          }, null, 8, ["item"])
        ])
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ]),
    _createVNode(NomenclatureExcelUploadModal, {
      onHide: _cache[6] || (_cache[6] = ($event: any) => (nomenclatureExcelUploadModalIsShow.value = false)),
      show: nomenclatureExcelUploadModalIsShow.value
    }, null, 8, ["show"])
  ]))
}
}

})